import { theme, Badge, Typography } from "antd";
import React from "react";
import { CustomTooltip } from "./CustomTooltip";

interface BetaTagProps {
  className?: string;
  style?: React.CSSProperties;
  size?: "dot" | "default" | "small";
}

export function BetaTag({
  className = "",
  style,
  size = "default",
}: BetaTagProps) {
  const { token } = theme.useToken();

  const tooltipContent = (
    <div>
      <Typography.Text strong>Beta notice</Typography.Text>
      <div
        style={{
          padding: "4px 2px",
          borderTop: `1px solid ${token.colorBorder}`,
        }}
      >
        This feature is in active development. Some capabilities may be limited
        or missing the mark. Your feedback is welcome as we work to improve it.
      </div>
    </div>
  );

  if (size === "dot") {
    return (
      <CustomTooltip content={tooltipContent}>
        <Badge
          dot
          style={{
            backgroundColor: token.colorPrimary,
            ...style,
          }}
          className={className}
        />
      </CustomTooltip>
    );
  }

  if (size === "small") {
    return (
      <CustomTooltip content={tooltipContent}>
        <span
          className={className}
          style={{
            backgroundColor: token.colorPrimaryBg,
            color: token.colorPrimary,
            padding: "2px 6px",
            borderRadius: "16px",
            fontSize: "10px",
            fontWeight: 300,
            display: "inline-flex",
            alignItems: "center",
            border: `1px solid ${token.colorPrimaryBorder}`,
            ...style,
          }}
        >
          Beta
        </span>
      </CustomTooltip>
    );
  }

  return (
    <CustomTooltip content={tooltipContent}>
      <span
        className={className}
        style={{
          backgroundColor: token.colorPrimaryBg,
          color: token.colorPrimary,
          padding: "4px 16px",
          borderRadius: "16px",
          fontSize: "14px",
          fontWeight: 500,
          display: "inline-flex",
          alignItems: "center",
          border: `1px solid ${token.colorPrimaryBorder}`,
          ...style,
        }}
      >
        Beta
      </span>
    </CustomTooltip>
  );
}
